import ProgramStudent from 'components/utilized/students/ProgramStudent'
import { useTranslation } from 'react-i18next'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'

const ParentProgramsPage = () => {

    const { t } = useTranslation()

    const { data: students } = useGET_studentsProfileSelectQuery({})
    
    
    return (

        <>

            {students?.list?.length > 0 && <ProgramStudent student={students.list[0].id} />}
        </>   
  )
}
export default ParentProgramsPage
